import { Endereco } from './endereco';

export class Empresa { // todo empresa já constituída com cnpj e outras informações de documentos
  id: number;
  cnpj: string;
  cga: string;
  endereco: Endereco;
  logomarca: string; // link da logomarca no S3 ou binário no banco
}